let workerURL = require('./helpers/get-worker-url');
let url = new __parcel__URL__(require('./helpers/bundle-manifest').resolve("gcOSA"));
module.exports = workerURL(url.toString(), url.origin, true);